import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserTopContentLayout({children}) {
    // Used in Exercisers to frame top content, made of
    // progress bar, question and answering block

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"mt-[32px] w-full flex flex-col justify-start items-center"}>
            {children}
        </div>
    )
}